const EMAIL_PATTERN = /^[^@\s]+@[^@\s]+\.[^@\s]+$/i;
const trustedTypesPolicy = window.trustedTypes?.createPolicy?.("subscribe-status-message", {
    createHTML: value => value,
});

const setStatus = (element, message, state = "info") => {
    if (element) {
        element.dataset.status = state;
        const text = trustedTypesPolicy?.createHTML(String(message)) ?? message;
        element.textContent = text;
    }
};

const setBusy = (button, isBusy) => {
    if (button) {
        button.disabled = isBusy;
        button.dataset.loading = isBusy ? "true" : "false";
    }
};

const handleSubmit = form => async event => {
    event.preventDefault();

    const emailInput = form.querySelector('input[type="email"]');
    const status = form.querySelector("[data-subscribe-status]");
    const submit = form.querySelector('[type="submit"]');
    const email = emailInput?.value.trim() || "";
    const action = form.getAttribute("action");

    if (!email || !EMAIL_PATTERN.test(email)) {
        setStatus(status, "Enter a valid email address.", "error");
        emailInput?.focus();
        return;
    }

    setBusy(submit, true);
    setStatus(status, "Subscribing...");

    try {
        const response = await fetch(action, {
            method: "POST",
            headers: {
                "content-type": "application/json",
                accept: "application/json",
            },
            body: JSON.stringify({
                email,
            }),
        });

        const data = await response.json().catch(() => ({}));
        const duplicate = data?.duplicate || response.status === 409;
        const ok = data?.ok || response.ok || duplicate;

        if (ok) {
            form.reset();
            setStatus(
                status,
                duplicate
                    ? "You're already subscribed. Thanks for following along!"
                    : "Thanks! Please check your inbox.",
                "success",
            );
            return;
        }

        const errorMessage = data?.error || "Subscription failed. Please try again.";
        throw new Error(errorMessage);
    } catch (error) {
        const message =
            error instanceof Error
                ? error.message
                : navigator.onLine
                  ? "Subscription failed. Please try again."
                  : "You appear to be offline. Try again once you're back online.";
        setStatus(status, message, "error");
        window.Sentry?.captureException?.(error);
    } finally {
        setBusy(submit, false);
    }
};

const subscribe = () => {
    document.querySelectorAll("[data-subscribe-form]").forEach(form => {
        form.addEventListener("submit", handleSubmit(form));
    });
};

export {subscribe};
